import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'approximate_number_of_workers_1'

export const dataPointDefinition = {
  retracedId: 'approximate_number_of_workers_1',
  name: 'Approximate number of workers',
  description:
    "Workers are persons working on/with the facility's product or directly involved in the operations of the facility. They are non-supervisory, which means no one reports to them.",
  meta: {
    slcpMeta: {
      key: 'fp-nat-10',
      number: 'FP-NAT-6',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nat-10', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27760,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
